const fr = {
  translation: {
    salutation: "Bonjour",
    introduction: "Je suis",
    introudction_job_title: "et je suis un",
    developer: "développeur",
    download: "télécharger",
    cv: "CV",
    select: "sélectionner",
    experiance_years: "{{years}} ans",
    of_experiance: "d'expérience",
    my_portofolio: "mon portfolio",
    portofolio: "portfolio",
    testimonials: "témoignages",
    all: "tous",
    about: "à propos",
    skill_level_question: "quel est mon niveau de compétence",
    see_more: "voir plus",
    achievements: "réalisations",
    personal_info: "informations personnelles",
    experience: "expérience",
    education: "éducation",
    skills_and_technology: "compétences et technologie",
    hide: "masquer",
    get_in_touch: "entrer en contact",
    send_message: "envoyer un message",
    message: "message",
    subject: "sujet",
    your_name: "votre nom",
    email_address: "adresse e-mail",
    talk_statment: "parlons de tout",
    like_form_question: "je n'aime pas les formulaires",
    send_me: "envoyez-moi un",
    email: "e-mail",
    language: "langue",
    home_page: "page d'accueil",
    me: "moi",
    my_experience: "mon expérience",
    coming_soon: "bientôt disponible",
    this_page_is_under_construction: "cette page est en construction",
    is_required_field: "{{field}} est un champ obligatoire",
  },
};

export default fr;
